module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "custom-page-title"
  }, [_c('h3', [_vm._v("\n            Miljø & sikkerhed\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "container pd-50"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12"
  }, [_c('h2', [_vm._v("\n                    Miljø- og sikkerhedskrav\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    P. Pedersen & Søn ved vores virksomhed er med til at påvirke miljøet og det samfund vi er en del af bl.a. gennem CO2udslip. Derfor udskifter vi løbende vores biler så vi overholder gældende EU normer.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    P. Pedersen & Søn:\n                    \n                    ")]), _c('div', {
    staticClass: "flex-wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fal fa-boxes fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Tager ansvar for kundernes varer\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fal fa-tree-alt fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Tager ansvar for miljøet\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fal fa-file-alt fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Har chauffører, som ALTID er opdaterede med gældende kurser og uddannelser\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fal fa-file-certificate fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Har altid opdaterede tilladelser / certificeringer inden for fødevaresikkerhed og fødevarehygiejne, farligt gods mm. i henhold til gældende love og regler\n                        ")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "border-radius": "4px"
    },
    attrs: {
      "src": "/static/images/snow.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63722278"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/environment.vue
// module id = 267
// module chunks = 1